import { Modal } from "react-bootstrap";

export function DeleteModal({ delName, deleteFunc, handleHide, show }: any) {
    if (delName === null) {
        return null;
    }
    return (
        <Modal
            onHide={handleHide}
            className="modal-sticky modal-sticky-lg modal-sticky-bottom-right"
            centered
            role="dialog"
            data-backdrop="false"
            aria-hidden="true"
            tabIndex="-1"
            size={"sm"}
            show={show}
            animation={false}
        >
            <div className={"modal-body"}>
                <p>
                    <span className={"fw-bold"}>{delName}</span>
                    {" حذف شود؟ "}{" "}
                </p>
                <div className={"d-flex gap-2"}>
                    <a onClick={deleteFunc} className={"btn btn-danger"}>
                        بله
                    </a>
                    <a
                        onClick={() => handleHide()}
                        className={"btn btn-secondary"}
                    >
                        خیر
                    </a>
                </div>
            </div>
        </Modal>
    );
}